import { Link } from 'react-router-dom';
import {
  Users,
  UserCheck,
  BarChart2,
  FileText,
  LayoutGrid,
  Shield
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import Navbar from '../components/Navbar';

export function AdministratorDashboard() {
  const { profile } = useAuth();

  return (
    <div className="min-h-screen bg-gray-100">
      <Navbar />

      {/* Hero section or banner */}
      <section className="relative bg-indigo-100 overflow-hidden">
        <img
          src="/chaos-soccer-gear-Cjfl8r_eYxY-unsplash.jpg"
          className="w-full h-64 object-cover opacity-70"
        />
        <div className="absolute inset-0 bg-indigo-900 bg-opacity-30 flex items-center justify-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white">
            Welcome, {profile?.first_name} {profile?.last_name}!
          </h2>
        </div>
      </section>

      {/* Main content */}
      <main className="max-w-7xl mx-auto py-10 px-4 sm:px-6 lg:px-8">
        <h3 className="text-2xl font-semibold mb-6 text-gray-800">Administrative Functions</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Manage Members */}
          <div className="bg-white shadow-md rounded-md p-5 flex flex-col items-center text-center">
            <Users className="w-10 h-10 text-indigo-600 mb-4" />
            <h4 className="text-lg font-semibold mb-2 text-gray-800">Manage Members</h4>
            <p className="text-gray-600 text-sm mb-4">
              Invite new members, edit roles, or remove members from the system.
            </p>
            <Link
              to="/members"
              className="bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 transition"
            >
              Go to Manage Members
            </Link>
          </div>

          {/* Manage Players */}
          <div className="bg-white shadow-md rounded-md p-5 flex flex-col items-center text-center">
            <UserCheck className="w-10 h-10 text-indigo-600 mb-4" />
            <h4 className="text-lg font-semibold mb-2 text-gray-800">Manage Players</h4>
            <p className="text-gray-600 text-sm mb-4">
              View player details, edit information, or remove players.
            </p>
            <Link
              to="/players"
              className="bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 transition"
            >
              Go to Manage Players
            </Link>
          </div>

          {/* Manage Evaluation Sessions */}
          <div className="bg-white shadow-md rounded-md p-5 flex flex-col items-center text-center">
            <BarChart2 className="w-10 h-10 text-indigo-600 mb-4" />
            <h4 className="text-lg font-semibold mb-2 text-gray-800">Evaluation Sessions</h4>
            <p className="text-gray-600 text-sm mb-4">
              Create new sessions, assign coaches, and evaluate players.
            </p>
            <Link
              to="/evaluation-sessions"
              className="bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 transition"
            >
              Go to Sessions
            </Link>
          </div>

          {/* Manage Age Groups */}
          <div className="bg-white shadow-md rounded-md p-5 flex flex-col items-center text-center">
            <LayoutGrid className="w-10 h-10 text-indigo-600 mb-4" />
            <h4 className="text-lg font-semibold mb-2 text-gray-800">Manage Age Groups</h4>
            <p className="text-gray-600 text-sm mb-4">
              Create and manage age groups for players.
            </p>
            <Link
              to="/age-groups"
              className="bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 transition"
            >
              Go to Age Groups
            </Link>
          </div>

          {/* Reports */}
          <div className="bg-white shadow-md rounded-md p-5 flex flex-col items-center text-center">
            <FileText className="w-10 h-10 text-indigo-600 mb-4" />
            <h4 className="text-lg font-semibold mb-2 text-gray-800">Reports</h4>
            <p className="text-gray-600 text-sm mb-4">
              Generate system-wide reports including waiver status.
            </p>
            <Link
              to="/reports"
              className="bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 transition"
            >
              Go to Reports
            </Link>
          </div>

          {/* Manage Teams */}
          <div className="bg-white shadow-md rounded-md p-5 flex flex-col items-center text-center">
            <Shield className="w-10 h-10 text-indigo-600 mb-4" />
            <h4 className="text-lg font-semibold mb-2 text-gray-800">Manage Teams</h4>
            <p className="text-gray-600 text-sm mb-4">
              Create and manage teams, assign coaches and players.
            </p>
            <Link
              to="/teams"
              className="bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 transition"
            >
              Go to Teams
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}